function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M61 61H1V1h60v60zM31 1v60m0-36.429h30M46 1v23.571M1 43.857h30",
  stroke: "#000",
  strokeWidth: 0.72,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
});
const SvgTreeMap = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 62,
  height: 62,
  viewBox: "0 0 62 62",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTreeMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tree-map.9fdb4fc2.svg";
export { ForwardRef as ReactComponent };